import React,{useState} from 'react';
import classes from './ContactForm.css';
import Button from '../../UI/Button/Button';
import {withFormik,Form,Field} from 'formik';
import * as Yup from 'yup';
import axios from '../../../firebase-axios';
import Popup from "react-popup";
import {sendEmailToAdmin} from '../../../helpers/EmailHelper';
import Loader from '../../UI/Loader/Loader';

const contactFrom = ({errors,touched,isSubmitting}) => {
let form = (
    <Form>
                    
    <div className={classes.appFormGroup}>
        <label htmlFor="name">Name:</label>
        <Field className={classes.appFormControl} type="text" name="name" id="name" />
        {touched.name && errors.name && <p>{errors.name}</p>}
    </div>

    <div className={classes.appFormGroup}>
        <label htmlFor="email">Email:</label>
        <Field className={classes.appFormControl} type="email" name="email" id="email" />
        {touched.email && errors.email && <p>{errors.email}</p>}
    </div>

    
    <div className={classes.appFormGroup}>
        <label htmlFor="subject">Subject:</label>
        <Field className={classes.appFormControl} type="text" name="subject" id="subject" />
        {touched.subject && errors.subject && <p>{errors.subject}</p>}
    </div>

    <div  className={classes.appFormGroup} >
        <label htmlFor="message">Message:</label>
        <Field component="textarea" className={classes.appFormControl} rows="5" name="message" id="subject"/>
        {touched.message && errors.message && <p>{errors.message}</p>}
    </div>
    <Button isContactMe submit ><i className="fa fa-send"></i>&nbsp;Send</Button>
</Form>
);
if(isSubmitting) {
    form = <Loader/>
}
return (<div className={classes.contactForm}>
        {form}
        </div>
        )
};

const formik = withFormik({
    mapPropsToValues({name,email,subject,message}) {
        return {
            name:name || '',
            email:email || '',
            subject:subject || '',
            message:message || ''
        }
    },
    validationSchema:Yup.object().shape({
        name:Yup.string().required('Name is required').max(30,'Max length is 30 characters'),
        email:Yup.string().required('Email is required').email('Incorrect email format'),
        subject:Yup.string().required('Subject is required').max(80,'Max length is 80 characters'),
        message:Yup.string().required('Message is required').max(500,'Max length is 500 characters')
    }),
    handleSubmit(values,{resetForm,setSubmitting}) {

        axios.post('contacts.json',values)
        .then(() => {
            sendEmailToAdmin(values)
            .then(
            (res) => {
                setSubmitting(false);
                Popup.alert('Thanks, for you email i will replay as soon as possible.');
                resetForm();
            },
            (err) => {
                setSubmitting(false);
                Popup.alert('unable to send email to admin. But email is added contact you soon.');
                resetForm();
                console.log(err);
            })
        })
        .catch(() => {
            setSubmitting(false);
            Popup.alert('Something went wrong.Please try again');
        });
    }
})(contactFrom);
export default formik;


// WEBPACK FOOTER //
// ./src/components/Sections/ContactForm/ContactForm.js